import { spacing } from '@mui/system';

export const MuiCardContent = {
  styleOverrides: {
    root: {
      ...spacing({ 'py': 3 }),
      width: '100%'
    },
  },
};
